// extracted by mini-css-extract-plugin
module.exports = {"circle":"CircleAnimation_circle__Bial6","circleContainer":"CircleAnimation_circleContainer__aUXFl","scale":"CircleAnimation_scale__m_6HP"};